var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.$isFlag && _vm.isShow
      ? _c("div", { staticClass: "headerWeb" }, [
          _c("p", { staticClass: "p1" }, [
            _c("span"),
            _vm._v(_vm._s(_vm.titleArray[0]))
          ]),
          _c("p", { staticClass: "p2" }, [
            _vm._v(" " + _vm._s(_vm.titleArray[1]) + " / "),
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.spanClick(_vm.titleArray[2])
                  }
                }
              },
              [_vm._v(_vm._s(_vm.titleArray[2]))]
            ),
            _vm._v("/ "),
            _c(
              "span",
              {
                class: _vm.titleArray.length >= 5 ? "hasFourMenu" : "",
                on: {
                  click: function($event) {
                    return _vm.spanClick(_vm.titleArray[3])
                  }
                }
              },
              [_vm._v(_vm._s(_vm.titleArray[3]))]
            ),
            _vm.titleArray.length >= 5
              ? _c("span", [_vm._v(" / " + _vm._s(_vm.titleArray[4]))])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm.$isFlag && _vm.titleMb
      ? _c(
          "div",
          { staticClass: "headerH5" },
          [
            _c("van-nav-bar", {
              attrs: { title: _vm.titleMb, "left-arrow": _vm.leftArrow },
              on: { "click-left": _vm.onClickLeft }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }